document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('.review-drawer');
  if (!drawer) return;

  function openReviewDrawer() {
    document.body.classList.add('open-review-drawer');
  }

  function closeReviewDrawer() {
    document.body.classList.remove('open-review-drawer');
  }

  function updateTriggerVisibility() {
    var triggers = document.querySelectorAll('.product-review-trigger, .product-review-accordion');
    var reviewCount = drawer.querySelectorAll('.yotpo-reviews-item').length;
    triggers.forEach(function (trig) {
      var minReviews = parseInt(trig.dataset.minReviews, 10) || 5;
      trig.classList.toggle('product-review-trigger--visible', reviewCount >= minReviews);
    });
  }

  updateTriggerVisibility();

  new MutationObserver(updateTriggerVisibility).observe(drawer, {
    childList: true,
    subtree: true,
  });

  document.addEventListener(
    'click',
    function (e) {
      var triggerEl = e.target.closest('.product-review-trigger, .product-review-accordion');
      if (triggerEl) {
        e.preventDefault();
        e.stopPropagation();
        openReviewDrawer();
      }
    },
    true
  );

  document.querySelectorAll('[data-review-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeReviewDrawer);
  });
});
